import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";

const Returns = () => {
  const { t } = useTranslation("common");

  return (
    <Layout title={t("returns_policy") || "Returns & Refunds"}>
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
        <h1 className="text-h1 mb-6 text-gray-900 dark:text-white">
          {t("returns_policy") || "Returns & Refunds"}
        </h1>

        <div className="prose dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-h3 mb-3">
              {t("return_period") || "30-Day Return Policy"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("return_period_desc") ||
                "We want you to be completely satisfied with your purchase. If you are not happy with your order, you may return it within 30 days of purchase for a full refund."}
            </p>
          </section>

          <section>
            <h2 className="text-h3 mb-3">
              {t("eligibility") || "Eligibility"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("eligibility_desc") ||
                "To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging."}
            </p>
          </section>

          <section>
            <h2 className="text-h3 mb-3">
              {t("refund_process") || "Refund Process"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("refund_process_desc") ||
                "Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund. If approved, your refund will be processed to your original method of payment within 5-10 business days."}
            </p>
          </section>

          <section>
            <h2 className="text-h3 mb-3">
              {t("how_to_return") || "How to Initiate a Return"}
            </h2>
            <p className="text-body text-gray-600 dark:text-gray-400">
              {t("how_to_return_desc") ||
                "To initiate a return, please contact our customer support team at support@shopstore.com with your order number and reason for return."}
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default Returns;
